var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.screenSizes.includes('lg'))?_c('Pic',{staticClass:"Blob",attrs:{"alt":"","formats":['webp'],"loading":"lazy","src":("../assets/landing/" + _vm.name + ".png")}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }